import { defineComponent, inject, h } from 'vue';

const CAccordionButton = defineComponent({
    name: 'CAccordionButton',
    setup(_, { slots }) {
        const toggleVisibility = inject('toggleVisibility');
        const visible = inject('visible');
        return () => h('button', {
            type: 'button',
            'aria-expanded': !visible.value,
            class: ['accordion-button', { ['collapsed']: !visible.value }],
            onClick: () => toggleVisibility(),
        }, slots.default && slots.default());
    },
});

export { CAccordionButton };
//# sourceMappingURL=CAccordionButton.js.map
